<template >
    <div>
        <h2>404 SAYFA BULUNAMADI!</h2>
    </div>
</template>
<script>
export default {
    
}
</script>
